import { TestConfig, TestContext } from 'yup'

export function mustAgree<T>(message: string): TestConfig<'Yes' | 'No', T> {
  return {
    name: 'is-yes',
    skipAbsent: false,
    test(value: 'Yes' | 'No', ctx: TestContext<T>) {
      if (value !== 'Yes') {
        return ctx.createError({
          message: message,
        })
      }
      return true
    },
  }
}

export function mustSelectNo<T>(message: string): TestConfig<'Yes' | 'No', T> {
  return {
    name: 'is-no',
    skipAbsent: false,
    test(value: 'Yes' | 'No', ctx: TestContext<T>) {
      if (value !== 'No') {
        return ctx.createError({
          message: message,
        })
      }
      return true
    },
  }
}
